import { Card, CardContent, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'

interface ContractBrowserKPIProp {
  kpiInfo: any
  makeMtdYtdSummaryVisible?: any
}
const SingleCardKPI = ({ kpiInfo, makeMtdYtdSummaryVisible }: ContractBrowserKPIProp) => {
  const ref = useRef(null)
  useEffect(() => {
    if (ref) makeMtdYtdSummaryVisible?.()
  }, [ref])

  return (
    <Card id='eod-kpi' className='w-100 p-0' style={{ overflow: 'auto' }}>
      <CardContent ref={ref} className='d-flex flex-row p-0 justify-content-between'>
        {kpiInfo?.map((item: any, index: any) => {
          return (
            <div className='mx-1' key={index}>
              <Typography className='sl-quote-kpi-title'>
                {item?.kpiName}
              </Typography>
              <Typography className='sl-quote-kpi-value'>
                {item?.kpiValue}
              </Typography>
            </div>
          )
        })}
      </CardContent>
    </Card>
  )
}

export default SingleCardKPI
